<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'textarea',
    },
    placeholder: {
      type: String,
      default: '',
    },
    maxChars: {
      type: Number,
      default: -1,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value,
      config: {
        key: process.env.FROALA_KEY,
        attribution: false,
        charCounterCount: true,
        charCounterMax: this.maxChars,
        codeMirror: window.CodeMirror,
        codeBeautifierOptions: {
          end_with_newline: false,
          indent_inner_html: true,
          extra_liners: '[\'p\', \'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'blockquote\', \'pre\', \'ul\', \'ol\', \'table\', \'dl\']', /* eslint-disable-line */
          brace_style: 'expand',
          indent_char: ' ',
          indent_size: 2,
          wrap_line_length: 0,
        },
        editorClass: 'tw-wysiwyg__editor',
        immediateVueModelUpdate: false,
        listAdvancedTypes: false,
        toolbarButtons: {
          moreText: {
            buttons: [
              'bold',
              'italic',
              'underline',
              'clearFormatting',
              'inlineClass',
            ],
            buttonsVisible: 4,
          },
          moreParagraph: {
            buttons: [
              'paragraphFormat',
              'formatOLSimple',
              'formatUL',
            ],
            buttonsVisible: 4,
          },
          moreRich: {
            buttons: [
              'insertLink',
            ],
          },
          moreMisc: {
            buttons: [
              'undo',
              'redo',
              'html',
            ],
            buttonsVisible: 3,
            align: 'right',
          },
        },
        paragraphFormat: {
          N: 'Normal',
          H1: 'Heading 1',
          H2: 'Heading 2',
          H3: 'Heading 3',
          H4: 'Heading 4',
          H5: 'Heading 5',
          H6: 'Heading 6',
        },
        toolbarSticky: false,
        heightMin: 250,
        heightMax: 251,
        pastePlain: false,
        linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
        linkInsertButtons: ['linkBack', '|'],
        htmlAllowedAttrs: ['href', 'target', 'title'],
        htmlAllowedTags: [
          'a',
          'b',
          'br',
          'div',
          'em',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'i',
          'li',
          'ol',
          'p',
          's',
          'span',
          'strike',
          'strong',
          'u',
          'ul',
        ],
        htmlAllowComments: false,
        htmlExecuteScripts: false,
        placeholder: this.placeholder,
        events: {
          initialized: this.onInitialize,
        },
      },
    };
  },
  methods: {
    onChange($event) {
      this.$emit('change', $event);
    },
    onInitialize() {
      this.$nextTick(() => {
        this.setEditorAvailability(!this.disabled);
      });
    },
    setEditorAvailability(status) {
      const editor = this.$refs.wysiwyg.getEditor();
      if (status) {
        editor.edit.on();
      } else {
        editor.edit.off();
      }
    },
  },
  watch: {
    disabled(v) {
      this.setEditorAvailability(!v);
    },
  },
};
</script>

<template>
  <div class="tw-wysiwyg">
    <froala
      v-model="internalValue"
      :config="config"
      :tag="tag"
      @input="onChange"
      ref="wysiwyg"
      disable
    />
  </div>
</template>

<style lang="scss">
  .tw-wysiwyg {
    &__editor {
      border: none;

      .fr-view {
        font-family: 'Roboto', sans-serif !important;
      }

      .fr-code {
        padding: 20px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TwWysiwyg.vue